import Vue from 'vue'

Vue.filter('toCurrency', value => {
  if (typeof value !== 'number') {
    return value
  }
  var formatter = new Intl.NumberFormat('id-ID', {
    minimumFractionDigits: 0,
    style: 'decimal'
  })
  return formatter.format(value)
})

Vue.filter('toLowerCase', value => {
  return value.toLowerCase()
})

Vue.filter('slugFormat', value => {
  const kebab = value.replace(/\-/g, ' ')
  const camel = kebab.replace(/([A-Z])/g, ' $1')
  const capitaize = camel.replace(/(^\w{1})|(\s{1}\w{1})|(?:dx)/g, match =>
    match.toUpperCase()
  )

  return capitaize
})
